import gql from 'graphql-tag';

const MUTATION_ADD_PLAN_TO_GROUP = gql`
	mutation AddPlanToGroup($employee: PurchaseEmployee!, $planID: String!) {
		addPlanToGroup(employee: $employee, planID: $planID)
	}
`;

export default MUTATION_ADD_PLAN_TO_GROUP;